import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { TASK_SUB_CATEGORY_API } from "../apiRoutes";

const mutateAddSubCategory = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${TASK_SUB_CATEGORY_API}`, data);
};

const useAddSubCategoryMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddSubCategory,
    ...queryParams,
  });

export default useAddSubCategoryMutation;
